// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ACMp","type":"styles_type__3GvYK","choices":"styles_choices__lyVQ7"};